// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // TODO: Add SDKs for Firebase products that you want to use
import { getAuth } from "firebase/auth";
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC7Q3sGTXelUlXvEzj7iNcylb2xE1pbtLE",
  authDomain: "bmwi4-55537.firebaseapp.com",
  projectId: "bmwi4-55537",
  storageBucket: "bmwi4-55537.firebasestorage.app",
  messagingSenderId: "965112351368",
  appId: "1:965112351368:web:49626108636ccc7d766d3d",
};
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);


export const auth = getAuth(app);